import { create, updateSectionA } from 'actions/driverOnboarding'
import DriverOnboarding from 'api/DriverOnboarding'
import DriverOnboardingV4 from 'api/DriverOnboardingV4'
import VerificationInput from 'components/Common/VerificationInput'
import { MAX_CODE_APPROVAL, OTHER_OPTION } from 'constants/appConstants'
import { LOGO_DELIVEREE_GREEN, LOGO_TRANSPORTIFY } from 'constants/imageConstants'
import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import { withTranslation, Trans } from 'react-i18next'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'
import { WAITING_EXAM, SECTION_A_COMPLETE, SUSPEND_COMPETITOR_APP, BLACKLISTED } from 'constants/dynamicFieldConstants'
import { isEmpty, get }  from 'lodash'
import { trackEventFBPixel, EventNameConstant } from 'utils/facebookPixel'
import { fnSuspendCompetitorApp } from 'utils/common'

import './Detail.scss'
import { _ } from 'core-js'

class Detail extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      loading: false,
      code: props.approvalCode || '',
      error: '',
    }

    this.driverOnboardingAPI = new DriverOnboarding()
    this.driverOnboardingAPIV4 = new DriverOnboardingV4()
  }

  componentDidMount() {
    const { approvalCode } = this.props
    if (approvalCode && approvalCode.length === MAX_CODE_APPROVAL) {
      this.handleVerifyApprovalCode(approvalCode)
      return
    }

    // In case user doesn't attempt to sign in with approval code
    // Check and save parameters for source tracking (marketing purpose)
    const { location } = this.props
    if (location.search) {
      this.props.updateSectionA({
        values: { platform: location.search }
      })
    }

    // Only trigger event complete registration if exists driverOnboarding data
    trackEventFBPixel(EventNameConstant.DRIVER_SIGN_UP_START)

  }

  handleCodeChange = (newCode) => {
    this.setState({ code: newCode })
  }

  handleApply() {
    window._$g.rdr('complete_application')
  }

  handleVerifyApprovalCode = async (approvalCode) => {
    approvalCode = approvalCode.toLowerCase()
    if (!approvalCode) return

    const { t, competitorApps } = this.props
    const verifyCountry = JSON.parse(window.localStorage.getItem('dlvr_verifyCountry'))
    const countryCode = verifyCountry.country_code
    try {
      // Reset error + show loading
      this.setState({
        loading: true,
        error: '',
      })

      let response = await this.driverOnboardingAPIV4.verifyTrainingCode({
        training_code: approvalCode,
        country_code: window._$g.country_code,
        has_competitor_app: competitorApps.length > 0,
        competitor_app_list: competitorApps.length > 0 ? competitorApps : []
      })
      const newDriverOnboarding = await this.props.saveStoreDriverOnboarding(response)

      if (isEmpty(newDriverOnboarding)) {
        if (response.approve_status === SUSPEND_COMPETITOR_APP) {
          fnSuspendCompetitorApp(response.approve_status)
        }
        this.setState({ loading: false })
        return
      } else {
        response = newDriverOnboarding
      }

      const approve_status = get(response, 'approve_status', '').toLowerCase()

      if (approve_status === BLACKLISTED) {
        this.setState({
          code: '',
          loading: false,
          error: <Trans i18nKey={t('verify_number.invalid_code_blacklist')}>
            {t('verify_number.invalid_code_blacklist')} {countryCode !== "id" && countryCode !== "ph" ? <a href="https://bit.ly/2YLgbpv">https://bit.ly/2YLgbpv</a> : ''}
          </Trans>, 
        })
        return
      }

      // As business required, 
      if (isEmpty(response) || !get(response, 'confirmed_sms')) {
        if (!_.isUndefined(response.driver_is_resignup) && !get(response, 'driver_is_resignup')) {
          this.setState({
            code: '',
            loading: false,
            error: t('verify_number.invalid_code'),
          })
          return
        }
      }
      // If code is invalid or area is OTHER, then return other page
      if (response.area_id === OTHER_OPTION || get(response, 'other_area', false)) {
        window._$g.rdr(`successful_page`)
        return
      }

      // Save approval code to session storage to support user reload section B, C
      sessionStorage.setItem('approval_code', approvalCode)

      // Otherwise, save result and redirect to finish application (SectionB + C)
      this.setState({ loading: false })

      // Start --- Go to by = approvalCode, Deeplink
      // Redirect exam
      const isOther = get(response, 'vehicle_info.is_other', false)
        || get(response, 'vehicle_type_is_blocked', false)
      const isRemote = get(response, 'is_remoted', false)
      
      // Redirect to Successful other page
      // SectionAComplete && Vehicle Type/Make/Mode === Other
      if (isOther && approve_status === SECTION_A_COMPLETE) {
        window._$g.rdr(`successful_page`)
        return
      }
      if (!isOther && isRemote &&  approve_status === WAITING_EXAM) {
        window._$g.rdr(`e_training/${response.id}?code=${approvalCode}`)
        return
      }
      if (get(response, 'driver_is_resignup')) {
        window._$g.rdr(`complete_application?approval_code=${approvalCode}`)
        return
      }
      // End ---- Go to by = approvalCode, Deeplink
      if (![WAITING_EXAM, SECTION_A_COMPLETE].includes(approve_status) || (approve_status === SECTION_A_COMPLETE && !isRemote)) {
        window._$g.rdr('finish_application')
        return
      }
    } catch (error) {
      console.log('Failed to verify training code: ', error)

      // Treat this case as an invalid code
      this.setState({
        code: '',
        loading: false,
        error: t('verify_number.invalid_code'),
      })
    }
  }

  render() {
    const { t } = this.props
    const { code, loading, error } = this.state

    return (
      <section className="sign-up">
        <div className="l-content">
          <div className="c-mainviewfull c-mainview-login">
            <div className="c-login-logo">
              <img src={window._$g.isTransportify ? LOGO_TRANSPORTIFY : LOGO_DELIVEREE_GREEN} height={60} alt="Logo Deliveree" />
            </div>

            <div className="c-login-description">
              <h2 className="">
                {t('sign_up.apply_now')}
              </h2>
              <button type="button" onClick={() => this.handleApply()}>
                {t('sign_up.get_stated')}
              </button>
            </div>

            <div className="sign-up__login-block">
              <p>{t('sign_up.approval_code')}</p>
              <p>{t('sign_up.enter_here')}:</p>

              <VerificationInput
                value={code}
                loading={loading}
                length={MAX_CODE_APPROVAL}
                onChange={this.handleCodeChange}
                onFulfilled={this.handleVerifyApprovalCode}
              />

              {error && <p className="sign-up__error">{error}</p>}
            </div>
          </div>
        </div>
      </section>
    )
  }
}

Detail.propTypes = {
  t: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  updateSectionA: PropTypes.func.isRequired,
}

Detail.defaultProps = {}

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    saveStoreDriverOnboarding: create,
    updateSectionA,
  }, dispatch)
)

const mapStateToProps = state => ({
  competitorApps: state.common.competitorApp,
})

export default connect(mapStateToProps, mapDispatchToProps)(
  withRouter(withTranslation()(Detail))
)

